import { useTranslation } from 'react-i18next';
import { Alert, Button } from 'reactstrap';

export interface PickListAutoSplitBannerProps {
  onOpenWizard: () => void;
}

export function PickListAutoSplitBanner({ onOpenWizard }: PickListAutoSplitBannerProps) {
  const { t } = useTranslation('picklist');
  return (
    <Alert color="warning" className="d-flex align-items-center justify-content-between gap-3 mb-3">
      <div>
        <i className="bi bi-exclamation-triangle me-2" />
        <strong>{t('auto_split_banner.title')}</strong>{' '}
        {t('auto_split_banner.body')}
      </div>
      <Button color="primary" size="sm" onClick={onOpenWizard}>{t('auto_split_banner.cta')}</Button>
    </Alert>
  );
}
